<template>
  <div class="auto-review-button-wrapper">
    <button
      class="btn auto-review-btn"
      @click="handleClick"
      :disabled="disabled"
      type="button"
    >
      <span
        v-if="isReReview"
        class="material-icons-round"
        aria-hidden="true">replay</span>
      <span
        v-else
        class="material-icons-outlined"
        aria-hidden="true">assignment_turned_in</span>
      <span class="button-text">{{ buttonText }}</span>
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AutoReviewButton',
  props: {
    criteriaSetName: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('goaldetail', ['autoReviewCompleted']),
    isReReview() {
      return this.autoReviewCompleted
    },
    buttonText() {
      return this.criteriaSetName ? `Auto-review (${this.criteriaSetName})` : 'Auto-review'
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
}
</script>

<style scoped lang="less">
.auto-review-button-wrapper {
  margin-top: 10px;
}

.auto-review-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 24px;
  background:
    linear-gradient(#FFFFFF, #FFFFFF) padding-box,
    var(--AI-AI-Blue-Pink) border-box;
  &:hover {
    background:
    linear-gradient(var(--gray-border-weak), var(--gray-border-weak)) padding-box,
    var(--AI-AI-Blue-Pink-Hover) border-box;
  }
  &:focus-visible {
    outline-offset: 2px;
    outline: 2px solid var(--AI-Blue);
  }
}

.auto-review-btn .material-icons-outlined,
.auto-review-btn .material-icons-round {
  font-size: 20px;
  background: var(--AI-AI-Blue-Pink);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
